<h2 class="notion-heading-3 px-[16px] mt-[16px] mb-[8px]">
  @for(c of data.heading_3.rich_text; track $index) {
  <app-notion-text-component [data]="c"></app-notion-text-component>
  }
</h2>
